module.exports = __webpack_public_path__ + "static/media/[Audio]2010-07-18-1.33a5b271.md";